<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<ng-container *ngIf="isScreenSmall">
  <fuse-vertical-navigation
    class="top-header dark bg-accent-900 print:hidden"
    [mode]="'over'"
    [name]="'mainNavigation'"
    [navigation]="navigation?.default"
    [opened]="false"
  >
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
      <!-- Logo assets/images/logo/logo-text-on-dark.svg -->
      <div
        class="flex flex-col items-center pt-6 px-8"
        [ngClass]="_persona.secondaryName?.trim() !== 'h20' ? 'h-32' : ''"
      >
        <div>
          <img class="w-24" [src]="_persona.logoFull" alt="Logo image" />
        </div>
        <div
          *ngIf="_persona.secondaryName?.trim() !== ''"
          class="w-60 font-bold text-center overflow-hidden overflow-ellipsis"
          style="line-height: 1.2; /* optional: to make text more compact */"
          [ngStyle]="{ direction: arabicPattern?.test(_persona.secondaryName) ? 'rtl' : 'ltr' }"
        >
          {{ _persona.secondaryName }}
        </div>
      </div>
    </ng-container>
  </fuse-vertical-navigation>
</ng-container>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0">
  <!-- Header -->
  <div
    class="top-header relative flex flex-0 items-center w-full px-4 md:px-6 z-49 shadow dark:border-b bg-card dark:bg-transparent print:hidden"
    [dir]="dir"
    [ngClass]="_persona?.secondaryName ? 'pb-8 h-28' : 'h-18'"
  >
    <ng-container *ngIf="!isScreenSmall">
      <!-- Logo + Secondary Text Container -->
      <div class="hidden lg:flex flex-row items-center gap-2 mx-2 lg:me-8">
        <!-- Logo -->
        <div>
          <img
            class="dark:hidden w-24 cursor-pointer min-w-24"
            [src]="lightHeaderLogoFull"
            alt="Logo"
            (click)="routeHome()"
          />
          <img
            class="hidden dark:flex w-24 cursor-pointer min-w-24"
            [src]="_persona.logoFull"
            (click)="routeHome()"
          />
        </div>

        <!-- Secondary Text -->
        <div
          *ngIf="_persona.secondaryName?.trim() !== ''"
          class="text-start font-bold overflow-hidden overflow-ellipsis"
          style="line-height: 1.2; /* optional: to make text more compact */"
          [ngStyle]="{ direction: arabicPattern?.test(_persona.secondaryName) ? 'rtl' : 'ltr' }"
        >
          {{ _persona.secondaryName }}
        </div>
      </div>

      <!-- Condensed version for small screens -->
      <div class="lg:hidden flex">
        <img
          class="dark:hidden w-8 cursor-pointer"
          [src]="lightHeaderLogoIcon"
          (click)="routeHome()"
          alt="Logo image"
        />
        <img
          class="hidden dark:flex w-8 cursor-pointer"
          [src]="_persona.logoIcon"
          (click)="routeHome()"
          alt="Logo image"
        />
        <div
          *ngIf="_persona.secondaryName?.trim() !== ''"
          class="mt-2 ms-2 text-center overflow-hidden overflow-ellipsis"
          style="line-height: 1.2; /* optional: to make text more compact */"
          [ngStyle]="{ direction: arabicPattern?.test(_persona.secondaryName) ? 'rtl' : 'ltr' }"
        >
          {{ _persona.secondaryName }}
        </div>
      </div>

      <!-- Horizontal navigation -->
      <fuse-horizontal-navigation
        [ngClass]="_persona?.secondaryName ? 'mt-24 absolute start-5' : 'me-2'"
        [name]="'mainNavigation'"
        [navigation]="navigation?.horizontal"
      ></fuse-horizontal-navigation>
    </ng-container>

    <!-- Navigation toggle button -->
    <ng-container *ngIf="isScreenSmall">
      <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
        <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
      </button>
    </ng-container>
    <!-- Components -->
    <div class="flex items-center ps-2 ms-auto space-x-2">
      <app-notifications></app-notifications>
      <help-menu></help-menu>
      <language-menu></language-menu>
      <user-menu></user-menu>
    </div>
  </div>

  <!-- Content -->
  <div class="flex flex-col flex-auto w-full">
    <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
         Otherwise, layout changes won't be registered and the view won't be updated! -->
    <router-outlet *ngIf="true"></router-outlet>
  </div>
</div>

<!-- Alerts -->
<fuse-alert
  class="absolute-x-center top-10 w-10/12"
  style="min-width: 250px; max-width: 500px; z-index: 5000"
  [appearance]="global.topMsg.appearance"
  [dismissible]="global.topMsg.dismissible"
  [dismissed]="global.topMsg.dismissed"
  [name]="global.topMsg.name"
  [type]="global.topMsg.type"
>
  <span fuseAlertTitle *ngIf="global.topMsg.title">{{ global.topMsg.title }}</span>
  <span [innerHTML]="global.topMsg.body"></span>
</fuse-alert>
